import * as yup from "yup";

export const invalidAccountNo = "please check and try again!";
export const minWithdrawable = "minimum withdrawable amount must be ₦1,500!";
export const maxWithdrawable = "maximum withdrawable amount must be ₦25,000!";

export const bankSchema = yup.object().shape({
  bankId: yup
    .string()
    .uuid()
    .required(),
  accountNo: yup
    .string()
    .min(9, invalidAccountNo)
    .required(),
});

export const withdrawalSchema = yup.object().shape({
  amount: yup
    .number()
    .min(1500, minWithdrawable)
    .max(200000, maxWithdrawable)
    .required(),
  bankPreferenceId: yup
    .string()
    .uuid()
    .required(),
});